const HOVER_GREEN = "rgb(34 197 94)";

/**
 * Shared react-select styling for the dashboard filter bars and forms.
 *
 * Two things every control on this dashboard needs:
 *  - the same 40px resting height as <Input> / <Select>, so a filter row that
 *    mixes all three lines up instead of looking ragged;
 *  - a capped value container. Picking "All" on a multi-select can add several
 *    hundred chips, and an uncapped control grows to thousands of pixels,
 *    pushing the rest of the filter row into a huge blank area.
 *
 * @param {object} [options]
 * @param {number} [options.maxValueHeight] max px height of the chip area
 *   before it scrolls. Defaults to ~2 rows of chips.
 */
export const buildSelectStyles = ({ maxValueHeight = 76 } = {}) => ({
  control: (base) => ({
    ...base,
    minHeight: "40px",
    borderRadius: "0.375rem",
    borderColor: "transparent",
    minWidth: "100%",
    boxShadow: "none",
    "&:hover": {
      borderColor: HOVER_GREEN,
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
    maxHeight: `${maxValueHeight}px`,
    overflowY: "auto",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    alignSelf: "flex-start",
  }),
  multiValue: (base) => ({
    ...base,
    borderRadius: "4px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 30,
  }),
});

/** Default styling for filter-bar selects. */
export const filterSelectStyles = buildSelectStyles();

/** Slightly taller cap for selects inside forms/modals, where the field owns its row. */
export const formSelectStyles = buildSelectStyles({ maxValueHeight: 116 });

export default filterSelectStyles;
